/**
 * Messages liés à la gestion du marronnier
 */

module.exports = {

    mode: {
        button: {
            list: {
                label: 'Liste',
                altLabel: 'Afficher sous forme de liste.'
            },
            calendar: {
                label: 'Calendrier',
                altLabel: 'Afficher sous forme de calendrier.'
            }
        }
    },

    activitySectorsFiltered: {
        universal: 'Universel',
        sectorial: 'Sectoriel'
    },

    create: {
        button: {
            label: 'Ajouter'
        },
        modal: {
            title: 'Ajouter un marronnier'
        }
    },

    edit: {
        button: {
            label: 'Éditer',
            altLabel: 'Éditer l\'événement { event } du marronnier.'
        },
        modal: {
            title: 'Édition de l\'événement { event }'
        }
    },

    import: {
        button: {
            label: 'Importer des événements au marronnier'
        },
        modal: {
            title: 'Importation d\'événements au marronnier'
        }
    },

    consult: {
        button: {
            altLabel: 'Consulter les détails de l\'événement { event }.'
        },
        details: {
            sections: {
                date: 'Date',
                conversion: 'Statut',
                sectorial: 'Statut',
                description: 'Description',
                hook: 'Accroche'
            },
            publicationConverted: {
                yes: 'Converti en publication',
                no: 'Non converti en publication'
            }
        },
        slideshow: {
            title: 'Événements de la journée du { date }',
            navigation: {
                description: 'Naviguer entre les événements de cette journée'
            }
        }
    },

    convertInTask: {
        button: {
            label: 'Convertir en publication',
            altLabel: 'Convertir l\'événement { event } en publication.'
        },
        modal: {
            title: 'Convertir en publication',
            networks: {
                compatible: {
                    empty: 'Aucun réseau social compatible n\'a été trouvé.'
                }
            },
            creditsToUse: 'sera utilisé | sera utilisé | seront utilisés'
        },
        form: {
            convertInReturn: {
                error: 'Une erreur s\'est produite pendant la conversion de l\'événement { event }.',
                button: {
                    credits: {
                        label: '<a href="{ url }" title="">Access credits</a>.'
                    }
                },
                fields: {
                    networks: 'Choix du réseau',
                    withLogo: 'Afficher le logo sur le visuel',
                    logo: {
                        unknown: 'Uploader mon logo',
                        current: 'Votre logo est déjà uploadé, vous pouvez le modifier ci-dessous'
                    },
                    submit: 'Convertir en publication'
                }
            }
        }
    },

    list: {
        table: {
            fields: {
                importId: 'ID d\'importation',
                importParentId: 'ID d\'importation du parent',
                date: 'Date',
                title: 'Titre',
                preview: 'Visuel',
                description: 'Description',
                activitySectorsFiltered: 'Filtre',
                status: 'Statut',
                canvaUrl: 'Projet Canva'
            },
            canva: {
                button: {
                    label: 'Projet Canva'
                }
            }
        }
    },

    calendar: {
        event: {
            publicationConverted: {
                yes: 'Converti',
                no: 'Non converti'
            }
        }
    },

    // Suggestion de publication sur la page d'accueil du client
    publicationSuggestion: {
        title: 'Suggestion de post',
        section: {
            date: 'Date',
            hook: 'Accroche',
            status: 'Statut',
            description: 'Description',
        }
    }

};
